import styled from 'styled-components'

export const ProjectCount = styled.span`
  color: ${({ theme, value }) =>
    value > 0 ? theme.color.success : theme.color.error};
  font-weight: 500;
`
